import _ from 'lodash'

/**
 * Preloader
 */

export const load = (path = '') => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = path
    image.onload = resolve
    image.onerror = reject
  })
}

export const loads = (paths = null) => {
  return new Promise((resolve, reject) => {
    if (!paths || !_.isArray(paths)) {
      reject()
    }

    const promises = paths.map(path => load(path))

    Promise.all(promises)
      .then(() => resolve())
      .catch(error => console.log(error) || reject())
  })
}



// WEBPACK FOOTER //
// ./src/script/libs/preloader.js